const map = {
	"./0/Kambi/Header.mobile.layout.js": [
		14704,
		[
			12915,
			25610
		]
	],
	"./0/Kambi/Header.pc.layout.js": [
		99185,
		[
			12915,
			28427
		]
	],
	"./0/Poker/Header.mobile.layout.js": [
		50289,
		[
			12915,
			4251
		]
	],
	"./0/Poker/Header.pc.layout.js": [
		36984,
		[
			12915,
			73442
		]
	],
	"./0/Spectate/Header.mobile.layout.js": [
		74385,
		[
			12915,
			37299
		]
	],
	"./0/Spectate/Header.pc.layout.js": [
		90744,
		[
			12915,
			17786
		]
	],
	"./1/Kambi/Header.mobile.layout.js": [
		80853,
		[
			12915,
			28343
		]
	],
	"./1/Kambi/Header.pc.layout.js": [
		32940,
		[
			12915,
			52606
		]
	],
	"./1/Poker/Header.mobile.layout.js": [
		63688,
		[
			12915,
			14622
		]
	],
	"./1/Poker/Header.pc.layout.js": [
		13289,
		[
			12915,
			39743
		]
	],
	"./1/Spectate/Header.mobile.layout.js": [
		56254,
		[
			12915,
			41142
		]
	],
	"./1/Spectate/Header.pc.layout.js": [
		14763,
		[
			12915,
			26359
		]
	],
	"./101/Spectate/Header.mobile.layout.js": [
		43849,
		[
			12915,
			82323
		]
	],
	"./101/Spectate/Header.pc.layout.js": [
		35088,
		[
			12915,
			42074
		]
	],
	"./31/Kambi/Header.mobile.layout.js": [
		27720,
		[
			12915,
			51706
		]
	],
	"./31/Kambi/Header.pc.layout.js": [
		13975,
		[
			12915,
			13213,
			64251
		]
	],
	"./31/Poker/Header.mobile.layout.js": [
		86201,
		[
			12915,
			45821
		]
	],
	"./31/Poker/Header.pc.layout.js": [
		61696,
		[
			12915,
			21824
		]
	],
	"./31/Spectate/Header.mobile.layout.js": [
		15881,
		[
			12915,
			25125
		]
	],
	"./31/Spectate/Header.pc.layout.js": [
		72176,
		[
			12915,
			13213,
			68968
		]
	],
	"./58/Spectate/Header.mobile.layout.js": [
		17948,
		[
			12915,
			66242
		]
	],
	"./58/Spectate/Header.pc.layout.js": [
		24653,
		[
			12915,
			56387
		]
	],
	"./75/Kambi/Header.mobile.layout.js": [
		33440,
		[
			12915,
			90242
		]
	],
	"./75/Kambi/Header.pc.layout.js": [
		97121,
		[
			12915,
			15523
		]
	],
	"./75/Spectate/Header.mobile.layout.js": [
		23713,
		[
			12915,
			21205
		]
	],
	"./75/Spectate/Header.pc.layout.js": [
		95272,
		[
			12915,
			42136
		]
	],
	"./76/Kambi/Header.mobile.layout.js": [
		78187,
		[
			12915,
			77013
		]
	],
	"./76/Kambi/Header.pc.layout.js": [
		87030,
		[
			12915,
			80792
		]
	],
	"./76/Spectate/Header.mobile.layout.js": [
		21024,
		[
			12915,
			19010
		]
	],
	"./76/Spectate/Header.pc.layout.js": [
		6305,
		[
			12915,
			97763
		]
	],
	"./8/Poker/Header.mobile.layout.js": [
		1209,
		[
			12915,
			97235
		]
	],
	"./8/Poker/Header.pc.layout.js": [
		55808,
		[
			12915,
			66362
		]
	],
	"./8/Spectate/Header.mobile.layout.js": [
		77641,
		[
			12915,
			50107
		]
	],
	"./8/Spectate/Header.pc.layout.js": [
		38142,
		[
			12915,
			20360,
			82242
		]
	],
	"./81/Kambi/Header.mobile.layout.js": [
		77741,
		[
			12915,
			36423
		]
	],
	"./81/Kambi/Header.pc.layout.js": [
		32772,
		[
			12915,
			28755,
			39182
		]
	],
	"./81/Spectate/Header.mobile.layout.js": [
		97334,
		[
			12915,
			40316
		]
	],
	"./81/Spectate/Header.pc.layout.js": [
		18787,
		[
			12915,
			28755,
			78033
		]
	],
	"./84/Kambi/Header.mobile.layout.js": [
		34500,
		[
			12915,
			2110
		]
	],
	"./84/Kambi/Header.pc.layout.js": [
		43989,
		[
			25247
		]
	],
	"./84/Spectate/Header.mobile.layout.js": [
		89301,
		[
			12915,
			1773
		]
	],
	"./84/Spectate/Header.pc.layout.js": [
		77100,
		[
			12915,
			70608
		]
	],
	"./86/Spectate/Header.mobile.layout.js": [
		57823,
		[
			12915,
			89191
		]
	],
	"./86/Spectate/Header.pc.layout.js": [
		53074,
		[
			12915,
			20242,
			75054
		]
	],
	"./87/Spectate/Header.mobile.layout.js": [
		12500,
		[
			12915,
			10010
		]
	],
	"./87/Spectate/Header.pc.layout.js": [
		84741,
		[
			12915,
			5339
		]
	],
	"./88/Spectate/Header.mobile.layout.js": [
		62673,
		[
			12915,
			92921
		]
	],
	"./88/Spectate/Header.pc.layout.js": [
		13656,
		[
			12915,
			29692
		]
	],
	"./89/Spectate/Header.mobile.layout.js": [
		35006,
		[
			12915,
			46580
		]
	],
	"./89/Spectate/Header.pc.layout.js": [
		77035,
		[
			12915,
			20242,
			24137
		]
	],
	"./90/Spectate/Header.mobile.layout.js": [
		35608,
		[
			12915,
			782
		]
	],
	"./90/Spectate/Header.pc.layout.js": [
		86361,
		[
			12915,
			20242,
			60751
		]
	],
	"./91/Spectate/Header.mobile.layout.js": [
		3651,
		[
			12915,
			82795
		]
	],
	"./91/Spectate/Header.pc.layout.js": [
		39246,
		[
			12915,
			20242,
			91026
		]
	],
	"./92/Spectate/Header.mobile.layout.js": [
		20646,
		[
			12915,
			88236
		]
	],
	"./92/Spectate/Header.pc.layout.js": [
		85491,
		[
			12915,
			88545
		]
	],
	"./94/Spectate/Header.mobile.layout.js": [
		31108,
		[
			12915,
			27018
		]
	],
	"./94/Spectate/Header.pc.layout.js": [
		94933,
		[
			12915,
			23979
		]
	],
	"./95/Spectate/Header.mobile.layout.js": [
		40175,
		[
			12915,
			94775
		]
	],
	"./95/Spectate/Header.pc.layout.js": [
		86730,
		[
			12915,
			49182
		]
	],
	"./96/Poker/Header.mobile.layout.js": [
		21092,
		[
			12915,
			1744
		]
	],
	"./96/Poker/Header.pc.layout.js": [
		71189,
		[
			12915,
			25093
		]
	],
	"./96/Spectate/Header.mobile.layout.js": [
		11170,
		[
			12915,
			19240
		]
	],
	"./96/Spectate/Header.pc.layout.js": [
		77919,
		[
			12915,
			20360,
			8157
		]
	],
	"./default/Kambi/Header.mobile.layout.js": [
		94143,
		[
			12915,
			79105
		]
	],
	"./default/Kambi/Header.pc.layout.js": [
		33658,
		[
			95108
		]
	],
	"./default/Spectate/Header.mobile.layout.js": [
		55812,
		[
			12915,
			40976
		]
	],
	"./default/Spectate/Header.pc.layout.js": [
		48245,
		[
			39397
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 68133;
module.exports = webpackAsyncContext;